import React from 'react'
import { Link } from 'react-router-dom'

const NotFound = () => {
  return (
    <div className="d-flex align-items-center justify-content-center min-vh-100 bg-light">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-8 col-lg-6 text-center">
            <div className="card shadow-lg border-0">
              <div className="card-body p-5">
                <div className="mb-4">
                  <h1 className="display-1 fw-bold text-primary mb-0">404</h1>
                  <h2 className="h4 text-muted mb-3">Page Not Found</h2>
                </div>

                <div className="mb-4">
                  <p className="lead text-secondary mb-3">
                    {"Oops! The page you're looking for doesn't exist."}
                  </p>
                  <p className="text-muted">
                    {
                      'It might have been moved, deleted, or you entered the wrong URL.'
                    }
                  </p>
                </div>

                <div className="d-grid gap-2 d-md-block">
                  <Link to="/" className="btn btn-primary btn-lg me-md-2">
                    <i className="bi bi-house-fill me-2"></i>
                    Go Home
                  </Link>
                  <button
                    onClick={() => window.history.back()}
                    className="btn btn-outline-secondary btn-lg"
                  >
                    <i className="bi bi-arrow-left me-2"></i>
                    Go Back
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NotFound
